/* HOLK LP v2 — hk2.js */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    /* ---------- Countdown to local midnight ---------- */
    var timers = document.querySelectorAll('[data-hk2-countdown]');
    if (timers.length) {
      var tick = function () {
        var now = new Date();
        var end = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0); // next midnight
        var diff = Math.max(0, end - now);
        var h = Math.floor(diff / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);
        timers.forEach(function (t) {
          var hh = t.querySelector('[data-h]'), mm = t.querySelector('[data-m]'), ss = t.querySelector('[data-s]');
          if (hh) hh.firstChild.nodeValue = String(h).padStart(2, '0');
          if (mm) mm.firstChild.nodeValue = String(m).padStart(2, '0');
          if (ss) ss.firstChild.nodeValue = String(s).padStart(2, '0');
        });
      };
      tick();
      setInterval(tick, 1000);
    }

    /* ---------- Delivery date (now + N days) ---------- */
    document.querySelectorAll('[data-hk2-delivery]').forEach(function (el) {
      var days = parseInt(el.getAttribute('data-hk2-delivery'), 10) || 4;
      var d = new Date();
      d.setDate(d.getDate() + days);
      var names = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
      var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      el.textContent = names[d.getDay()] + ', ' + months[d.getMonth()] + ' ' + d.getDate();
    });

    /* ---------- Hero gallery ---------- */
    document.querySelectorAll('[data-hk2-gallery]').forEach(function (gal) {
      var slides = gal.querySelectorAll('.gal-slide');
      var thumbs = gal.querySelectorAll('.gal-thumb');
      thumbs.forEach(function (th, i) {
        th.addEventListener('click', function () {
          slides.forEach(function (s, j) { s.classList.toggle('active', i === j); });
          thumbs.forEach(function (t, j) { t.classList.toggle('active', i === j); });
        });
      });
    });

    /* ---------- Accordions (included + faq) ---------- */
    document.querySelectorAll('[data-hk2-acc]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('[data-hk2-acc-item]');
        if (!item) return;
        var group = item.closest('[data-hk2-acc-group]');
        var wasOpen = item.classList.contains('open');
        if (group && group.hasAttribute('data-hk2-acc-single')) {
          group.querySelectorAll('[data-hk2-acc-item].open').forEach(function (o) { o.classList.remove('open'); });
        }
        item.classList.toggle('open', !wasOpen);
      });
    });

    /* ---------- UGC video lightbox ---------- */
    var lb = document.querySelector('.hk2-lightbox');
    var lbSlot = lb ? lb.querySelector('.lb-slot') : null;
    function closeLb() {
      if (!lb) return;
      lb.classList.remove('open');
      if (lbSlot) lbSlot.innerHTML = '';
    }
    document.querySelectorAll('[data-hk2-video]').forEach(function (card) {
      card.addEventListener('click', function () {
        var url = (card.getAttribute('data-hk2-video') || '').trim();
        if (!url || !lb || !lbSlot) return;
        var node;
        if (/youtube\.com|youtu\.be/.test(url)) {
          var id = (url.match(/(?:v=|youtu\.be\/|shorts\/)([\w-]{6,})/) || [])[1] || '';
          node = document.createElement('iframe');
          node.src = 'https://www.youtube.com/embed/' + id + '?autoplay=1&playsinline=1';
          node.allow = 'autoplay; encrypted-media; fullscreen';
        } else if (/vimeo\.com/.test(url)) {
          var vid = (url.match(/vimeo\.com\/(\d+)/) || [])[1] || '';
          node = document.createElement('iframe');
          node.src = 'https://player.vimeo.com/video/' + vid + '?autoplay=1';
          node.allow = 'autoplay; fullscreen';
        } else {
          node = document.createElement('video');
          node.src = url;
          node.controls = true;
          node.autoplay = true;
          node.playsInline = true;
        }
        lbSlot.innerHTML = '';
        lbSlot.appendChild(node);
        lb.classList.add('open');
      });
    });
    if (lb) {
      lb.addEventListener('click', function (e) { if (e.target === lb) closeLb(); });
      var x = lb.querySelector('.lb-close');
      if (x) x.addEventListener('click', closeLb);
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeLb(); });
    }

    /* ---------- Reviews: load more ---------- */
    document.querySelectorAll('[data-hk2-more]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var grid = document.querySelector(btn.getAttribute('data-hk2-more'));
        if (!grid) return;
        grid.querySelectorAll('.hidden-rv').forEach(function (c) { c.classList.remove('hidden-rv'); });
        btn.closest('.rv-more').style.display = 'none';
      });
    });

    /* ---------- Sticky buy bar ---------- */
    var sticky = document.querySelector('.hk2-sticky');
    var sentinel = document.querySelector('[data-hk2-hero-cta]');
    if (sticky && sentinel && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          sticky.classList.toggle('show', !en.isIntersecting);
        });
      }, { threshold: 0 });
      io.observe(sentinel);
    } else if (sticky) {
      window.addEventListener('scroll', function () {
        sticky.classList.toggle('show', window.scrollY > 900);
      }, { passive: true });
    }

    /* ---------- Stock bar animation ---------- */
    document.querySelectorAll('[data-hk2-stock]').forEach(function (bar) {
      var pct = parseInt(bar.getAttribute('data-hk2-stock'), 10) || 85;
      var fill = bar.querySelector('i');
      if (!fill) return;
      if ('IntersectionObserver' in window) {
        var so = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting) { fill.style.width = pct + '%'; so.disconnect(); }
          });
        }, { threshold: .4 });
        so.observe(bar);
      } else {
        fill.style.width = pct + '%';
      }
    });

    /* ---------- Bundle selector ---------- */
    (function () {
      var wraps = document.querySelectorAll('[data-hk2-bundles]');
      wraps.forEach(function (wrap) {
        var opts = wrap.querySelectorAll('[data-hb-opt]');
        var cta  = wrap.querySelector('[data-hb-cta]');
        var lbl  = wrap.querySelector('[data-hb-cta-label]');
        var sbBar = document.querySelector('.hk2-sticky');
        var sbNow = sbBar && sbBar.querySelector('.now');
        var sbBtn = sbBar && sbBar.querySelector('a.btn');
        function apply(opt) {
          opts.forEach(function (o) { o.classList.remove('is-on'); var i = o.querySelector('input'); if (i) i.checked = false; });
          opt.classList.add('is-on');
          var inp = opt.querySelector('input'); if (inp) inp.checked = true;
          var href = opt.getAttribute('data-checkout');
          var lblTxt = opt.getAttribute('data-cta-label');
          if (cta && href) cta.setAttribute('href', href);
          if (lbl && lblTxt) lbl.textContent = lblTxt;
          // mirror to sticky bar
          if (sbBtn && href) sbBtn.setAttribute('href', href);
          if (sbNow) {
            var p = opt.querySelector('.hb-now'); if (p) sbNow.textContent = p.textContent;
          }
        }
        opts.forEach(function (opt) {
          opt.addEventListener('click', function (e) {
            // avoid double-fire when clicking the native input
            if (e.target && e.target.tagName === 'INPUT') return;
            apply(opt);
          });
          var inp = opt.querySelector('input');
          if (inp) inp.addEventListener('change', function () { apply(opt); });
        });
        // init from any pre-checked / default
        var initial = wrap.querySelector('[data-hb-opt].is-on') || opts[0];
        if (initial) apply(initial);
      });
    })();

    /* ---------- Reveal-on-scroll ---------- */
    (function () {
      // auto-tag common blocks
      var targets = document.querySelectorAll(
        '.hk2-sec .hk2-h2, .hk2-sec .hk2-lead, .hk2-sec .hk2-eyebrow, ' +
        '.hk2-included .iu-card, .hk2-included .inc-item, ' +
        '.hk2-steps .step, .hk2-reasons .r-card, .hk2-features .ft-card, ' +
        '.hk2-ugc .ugc-card, .hk2-compare table, .hk2-stats .stat, ' +
        '.hk2-guarantee .g-card, .hk2-faq details, .hk2-reviews .rv-card'
      );
      targets.forEach(function (el, i) {
        if (!el.hasAttribute('data-hk2-reveal')) el.setAttribute('data-hk2-reveal', '');
        el.style.setProperty('--hk2-delay', ((i % 6) * 60) + 'ms');
      });
      if (!('IntersectionObserver' in window)) {
        document.querySelectorAll('[data-hk2-reveal]').forEach(function (el) { el.classList.add('is-in'); });
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
        });
      }, { threshold: .12, rootMargin: '0px 0px -8% 0px' });
      document.querySelectorAll('[data-hk2-reveal]').forEach(function (el) { io.observe(el); });
    })();

    /* ---------- Stock counter (scarcity) ---------- */
    (function () {
      var stock = document.querySelector('[data-hk2-stock]');
      if (!stock) return;
      var numEl = stock.querySelector('[data-hk2-stock-num]');
      var barEl = stock.querySelector('[data-hk2-stock-bar]');
      if (!numEl || !barEl) return;

      // Persist across reloads within the day so the number only goes down.
      var key = 'hk2_stock_' + (location.pathname || '/');
      var todayStr = new Date().toISOString().slice(0, 10);
      var start = parseInt(numEl.textContent, 10) || 42;
      var stored = null;
      try { stored = JSON.parse(localStorage.getItem(key) || 'null'); } catch (e) {}
      var current;
      if (stored && stored.day === todayStr && typeof stored.n === 'number' && stored.n <= start) {
        current = stored.n;
      } else {
        current = start;
        try { localStorage.setItem(key, JSON.stringify({ day: todayStr, n: current })); } catch (e) {}
      }

      function paint() {
        numEl.textContent = current;
        // Bar goes DOWN as stock drops. Start 45% full, empty at 3 remaining.
        var pct = Math.max(6, Math.min(60, (current / 100) * 100));
        barEl.style.width = pct + '%';
      }
      // Initial paint after next frame so the CSS transition animates in
      requestAnimationFrame(function () { barEl.style.width = '0%'; requestAnimationFrame(paint); });

      // Decrement 1 unit every 45-90s, min 3
      function tick() {
        if (current > 3) {
          current -= 1;
          try { localStorage.setItem(key, JSON.stringify({ day: todayStr, n: current })); } catch (e) {}
          paint();
        }
        setTimeout(tick, 45000 + Math.random() * 45000);
      }
      setTimeout(tick, 25000 + Math.random() * 15000);
    })();

    /* ---------- Smooth anchor scroll ---------- */
    document.querySelectorAll('.hk2 a[href^="#"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var id = a.getAttribute('href').slice(1);
        var target = document.getElementById(id);
        if (target) {
          e.preventDefault();
          var y = target.getBoundingClientRect().top + window.scrollY - 70;
          window.scrollTo({ top: y, behavior: 'smooth' });
        }
      });
    });
  });
})();
